import React from 'react';
import { ProgramModel } from '@biw/contests-core/lib/dux/programs';

interface Props {
    program: ProgramModel;
}

const ProgramLogo = ( { program }: Props ) => (
    <div className="header-logo">
        <img height="auto" width="100%" src={program.programLogo} alt={program.programName || 'Program Logo'} />
    </div>
);

export default ProgramLogo;
